import { createContext, useContext as useReactContext } from 'react';
import { getCurrentConsumer } from '../internals/consumer.js';
export const ScopeContext = createContext(undefined);
export function useScope() {
    return useReactContext(ScopeContext);
}
export function useContext(context) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const scope = getCurrentConsumer()?.scope ?? useScope();
    if (!scope) {
        throw new Error('useContext must be used within a signal hook, a withContext, or a component');
    }
    return scope.getContext(context) ?? context.defaultValue;
}
